export const TEXTS = {
  MODAL_BIND_SUCCESS_TITLE: 'Устройство привязано!',
  MODAL_BIND_SUCCESS_TITLE_ON_REQUESTED: 'Волна привязана!',

  MODAL_BIND_SUCCESS_NO_STREAM_DESC: 'Выберите музыку для своего заведения',
  MODAL_BIND_SUCCESS_NO_VIDEO_STREAM_DESC: 'Выберите видео для своего заведения',

  MODAL_BIND_SUCCESS_ADDRESS_NO_ACTIVE_DESC: 'Для запуска необходимо оплатить адрес',
  MODAL_BIND_SUCCESS_DESC: 'Треки загружаются. Музыка заиграет на вашем плеере в ближайшее время, ожидайте.',
  MODAL_VIDEO_BIND_SUCCESS_DESC: 'Медиафайлы загружаются. Воспроизведение скоро начнется',

  MODAL_BIND_SUCCESS_DESC_SBER_DEVICE_REQUESTED: (isAddressEnabled?: boolean, isVideoStream: boolean = false) =>
    `Запрос на подключение плеера Звук Бизнес отправлен. После завершения привязки${isAddressEnabled ? ' ' : ' и оплаты адреса '}${isVideoStream ? 'видео' : 'музыка'} автоматически заиграет на вашем устройстве.`,
  MODAL_BIND_SUCCESS_DESC_SBER_BOOM_REQUESTED: (isAddressEnabled?: boolean) =>
    `Запрос на подключение умной колонки SberBoom отправлен. После завершения привязки${isAddressEnabled ? ' ' : ' и оплаты адреса '}музыка автоматически заиграет на вашем устройстве.`,
  MODAL_BIND_SUCCESS_DESC_SBER_DEVICE_AND_BOOM_REQUESTED: (isAddressEnabled?: boolean) =>
    `Запросы на подключение умной колонки SberBoom и плеера Звук Бизнес отправлены. После завершения привязки${isAddressEnabled ? ' ' : ' и оплаты адреса '}музыка автоматически заиграет на вашем устройстве.`,

  MODAL_BIND_SUCCESS_BUTTON_OPEN_STREAMS_TEXT: 'Выбрать волну',
  MODAL_BIND_SUCCESS_BUTTON_OPEN_VIDEO_STREAMS_TEXT: 'Выбрать видеоволну',
  MODAL_BIND_SUCCESS_BUTTON_OPEN_WEB_PLAYER_TEXT: 'Открыть веб-плеер',
  MODAL_BIND_SUCCESS_BUTTON_CLOSE_TEXT: 'Хорошо',
  MODAL_BIND_SUCCESS_BUTTON_TO_STREAMS_TEXT: (isVideoStream: boolean = false) =>
    `Вернуться к ${isVideoStream ? 'видео' : ''}волнам`,
};
